import { trpc } from "@/trpc";

/** The signed-in member's own feedback for an event (null until they leave some). */
export function useMyEventFeedback(eventId: string, enabled: boolean) {
  return trpc.members.eventFeedback.getMine.useQuery({ event_id: eventId }, { enabled });
}

/** Admin-only: every member's feedback for an event, plus the average. */
export function useEventFeedbackSummary(eventId: string) {
  return trpc.admin.eventFeedback.getByEvent.useQuery({ event_id: eventId });
}

/** Admin-only: the latest feedback across all events, for the dashboard. */
export function useRecentEventFeedback(limit = 5) {
  return trpc.admin.eventFeedback.listRecent.useQuery({ limit });
}

export function useSubmitEventFeedback() {
  const utils = trpc.useUtils();
  return trpc.members.eventFeedback.submit.useMutation({
    onSuccess: () => {
      utils.members.eventFeedback.getMine.invalidate();
    },
  });
}
